import api from '@/api/api'

const state = {
  authToken: localStorage.getItem('authToken'),
  currentUser: '',
  locale: localStorage.getItem('locale') ? localStorage.getItem('locale') : 'en'
}

const getters = {
  getAuthToken: state => state.authToken,
  getCurrentUser: state => state.currentUser,
  getLocale: state => state.locale
}

const mutations = {
  'SET_AUTH_TOKEN' (state, token) {
    state.authToken = token
    localStorage.setItem('authToken', state.authToken)
  },
  'SET_CURRENT_USER' (state, user) {
    state.currentUser = user
  },
  'SET_LOCALE' (state, locale) {
    state.locale = locale
  }
}

const actions = {
  loadAuthToken ({ commit }, token) {
    commit('SET_AUTH_TOKEN', token)
  },
  async fetchSelf ({ commit }) {
    let user = await api.fetchSelf()
    localStorage.setItem('user', user.data.data.roles[0].name)
    
    commit('SET_CURRENT_USER', user.data.data)
  },
  setLocale ({commit}, locale) {
    commit('SET_LOCALE', locale)

  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/authToken.js